module.exports = __webpack_public_path__ + "RO.png?aa9d7acc603d317b33c32016a2918b30";